export const WEB_SDK_TESTS_FILTER_SECTION_LABELS = {
	PAGE_TITLE: 'Web SDK Report',
	SHOW_ONLY_LATEST_TESTS: 'Show only the last report per test'
} as const;
